const MIN_DESKTOP_WIDTH = 981;

export const MOBILE_SCREEN = `(max-width: ${MIN_DESKTOP_WIDTH - 1}px)`;
export const DESKTOP_SCREEN = `(min-width: ${MIN_DESKTOP_WIDTH}px)`;

export const MOBILE_MEDIA_QUERY = `@media screen and ${MOBILE_SCREEN}`;
export const DESKTOP_MEDIA_QUERY = `@media screen and ${DESKTOP_SCREEN}`;
